<div class="page-container">
    <div class="flex min-w-0 items-center justify-between gap-4">
      <h1 class="main-heading min-w-0">Price List Template - {{ mode }}</h1>
      <app-navpath class="hidden md:block" />
    </div>
    <div class="mb-2 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <!-- Add -->
      <button *ngIf="mode === 'Add'" class="shorter-btn misc-btn" (click)="onSave()" [disabled]="!isFormValid()">
        <fa-icon [icon]="faPlus" class="mr-1" />Create
      </button>
    
      <!-- Edit -->
      <button *ngIf="mode === 'Edit'" class="shorter-btn misc-btn" (click)="onSave()" [disabled]="!isFormValid()">
        <fa-icon [icon]="faPencil" class="mr-1" />Update
      </button>
      <!-- Delete -->
      <button *ngIf="mode === 'Edit'" class="shorter-btn delete-btn" (click)="deleteTemplate()">
        <fa-icon [icon]="faTrash" class="mr-1" />Delete
      </button>
      <!-- Cancel -->
      <button class="shorter-btn clear-btn" (click)="onCancel()">
        <fa-icon [icon]="faBan" class="mr-1" />Cancel
      </button>
    </div>
    <div class="content-container">
      <app-data-form [dataFields]="formFields" />
    </div>
  </div>
